
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 3c7.168 0 13 5.832 13 13s-5.832 13-13 13S3 23.168 3 16 8.832 3 16 3zm-1.125 2.063A10.98 10.98 0 005 16.001c0 6.087 4.913 11 11 11 2.687 0 5.155-.938 7.063-2.531l-7.781-7.75-.281-.313V5.063c-.041.004-.084-.004-.125 0zm2.125 0v9.938h9.938A10.957 10.957 0 0017 5.063zM18.438 17l6.031 6.063c1.393-1.668 2.262-3.768 2.469-6.063h-8.5z"}})])
          )
        }
      }
    